<template>
  <div>
    <div
      v-if="!isMobile"
      class="rigging-trigger"
      @mouseenter="showPanel = true"
    />
    <div
      class="rigging-panel"
      :class="{ 'is-visible': showPanel }"
      @mouseleave="!isMobile ? showPanel = false : null"
    >
      <div class="panel-header">
        <span class="panel-title">Rigging</span>
        <button class="delete" @click="showPanel = false" />
      </div>

      <div class="panel-content">
        <div class="field">
          <b-switch v-model="riggingEnabled" type="is-danger">
            {{ riggingEnabled ? 'ON' : 'OFF' }}
          </b-switch>
        </div>

        <div v-if="riggingEnabled" class="rigging-controls">
          <div class="field">
            <label class="label">Target Entry:</label>
            <b-select v-model="targetEntryId" expanded>
              <option :value="null">-- Select --</option>
              <option
                v-for="entry in entries"
                :key="entry.id"
                :value="entry.id"
              >
                {{ entry.text || '(No text)' }}
              </option>
            </b-select>
          </div>

          <div v-if="targetEntry && !visualRigMode" class="target-display">
            <span class="tag is-danger">
              Will land on: {{ targetEntry.text }}
            </span>
          </div>

          <div class="field" style="margin-top: 12px">
            <b-checkbox v-model="visualRigMode" type="is-warning">
              Swap out all names
            </b-checkbox>
          </div>

          <div v-if="visualRigMode && targetEntry" class="target-display">
            <span class="tag is-warning">
              All entries → {{ targetEntry.text }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'RiggingPanel',
  data() {
    return {
      showPanel: false,
    }
  },
  computed: {
    ...mapGetters([
      'entries',
      'riggingEnabled',
      'rigTargetEntryId',
      'visualRigMode',
    ]),
    isMobile() {
      return this.$mq === 'mobile'
    },
    riggingEnabled: {
      get() {
        return this.$store.getters.riggingEnabled
      },
      set(value) {
        this.$store.commit('setRiggingEnabled', value)
      },
    },
    targetEntryId: {
      get() {
        return this.$store.getters.rigTargetEntryId
      },
      set(value) {
        this.$store.commit('setRigTargetEntryId', value)
      },
    },
    visualRigMode: {
      get() {
        return this.$store.getters.visualRigMode
      },
      set(value) {
        this.$store.commit('setVisualRigMode', value)
      },
    },
    targetEntry() {
      if (!this.targetEntryId) return null
      return this.entries.find((e) => e.id === this.targetEntryId)
    },
  },
  mounted() {
    this.$root.$on('toggle-rigging-panel', this.togglePanel)
  },
  beforeDestroy() {
    this.$root.$off('toggle-rigging-panel', this.togglePanel)
  },
  methods: {
    ...mapMutations([
      'setRiggingEnabled',
      'setRigTargetEntryId',
      'setVisualRigMode',
    ]),
    togglePanel() {
      this.showPanel = !this.showPanel
    },
  },
}
</script>

<style scoped>
.rigging-trigger {
  position: fixed;
  right: 0;
  top: 0;
  width: 20px;
  height: 100vh;
  z-index: 100;
}

.rigging-panel {
  position: fixed;
  right: -300px;
  top: 60px;
  width: 280px;
  background: rgba(45, 45, 45, 0.95);
  border-radius: 8px 0 0 8px;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
  transition: right 0.3s ease;
  z-index: 101;
  padding: 16px;
  color: white;
}

.rigging-panel.is-visible {
  right: 0;
}

.panel-header {
  border-bottom: 1px solid #555;
  padding-bottom: 8px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-title {
  font-weight: bold;
  font-size: 16px;
}

.rigging-controls {
  margin-top: 16px;
}

.target-display {
  margin-top: 12px;
}

.label {
  color: white;
  font-size: 14px;
}

/* Fix checkbox text visibility on hover */
::v-deep .b-checkbox.checkbox:hover {
  color: white !important;
}

::v-deep .b-checkbox.checkbox .check:hover + span {
  color: white !important;
}

::v-deep .b-checkbox.checkbox input:checked + .check + span {
  color: white !important;
}

::v-deep .b-checkbox.checkbox span {
  color: white !important;
}
</style>
